import { QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { Toaster } from 'sonner';

import { queryClient } from '@/app/queryClient';
import { DrawerProvider } from '@/components/Drawer/context/DrawerContext';
import { AuthProvider } from '@/providers/AuthProvider';
import { EnvironmentScopeProvider } from '@/providers/EnvironmentScopeProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { store } from '@/store';

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <EnvironmentScopeProvider>
              <DrawerProvider>
                {children}
                <Toaster richColors position="top-right" />
              </DrawerProvider>
            </EnvironmentScopeProvider>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
}
